module.exports = __webpack_public_path__ + "img/o1@2x.70dd8a67.png";